import moment from "moment";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import LocationTreeCheckboxComponent from "../../../components/location/location-tree-checkbox.component";
import SelectModelSearchInputComponent from "../../../components/model/select-model-search-input.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../../components/site/select-site-search-input.component";
import { formats } from "../../../config/constants";
import loginModel from "../../../models/login.model";
import SearchByIMEIModel from "../../../models/reports/search-by-imei.model";
import ViewBase from "../../view-base.view";

export default function SearchByIMEIView() {
  ViewBase.call(this);

  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';

  let saleDateFrom = moment().format(formats.dateFormat);
  let saleDateTo = moment().format(formats.dateFormat);

  let divisions = [];
  let selectedDivisions = [];

  let selectedModels = [];

  let imei = "";
  let selectedLocationCodeList = [];
  let selectedSites = [];
  let statuses = [];
  let selectedStatus;

  let selectedSortBy = "";
  let selectedOrderBy = "";

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  let searchResult;

  let prevSearchCache = {
    searchResult,
    saleDateFrom,
    saleDateTo,
    selectedDivisions,
    selectedModels,
    imei,
    selectedLocationCodeList,
    selectedSites,
    selectedStatus,

    updateCache() {
      this.searchResult = searchResult;
      this.saleDateFrom = saleDateFrom;
      this.saleDateTo = saleDateTo;
      this.selectedDivisions = selectedDivisions;
      this.selectedModels = selectedModels;
      this.imei = imei;
      this.selectedLocationCodeList = selectedLocationCodeList;
      this.selectedSites = selectedSites;
      this.selectedStatus = selectedStatus;
    }
  }

  const search = () => {
    this.showLoading();

    const criteria = {
      divisionGroups: selectedDivisions.map((d) => d.code).join("^"),
      location: selectedLocationCodeList.join("^"),
      sites: selectedSites.map((s) => s.siteId).join("^"),
      models: selectedModels.map((m) => m.modelCode).join("^"),
      imei: imei.split("\n").map(imei => imei.trim()).filter(imei => imei).join("^"),
      status: selectedStatus?.code || "",
      fromDate: moment(saleDateFrom).format(formats.apiDateFormat),
      toDate: moment(saleDateTo).format(formats.apiDateFormat),
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    };

    SearchByIMEIModel.search(criteria)
      .then((res) => {
        searchResult = res?.data || [];

        pagination.totalItems = res?.total || 0;
        pagination.pageIndex = res?.pageIndex || 1;
        pagination.pageSize = res?.pageSize || 10;

        prevSearchCache.updateCache();
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const searchWithCache = () => {
    this.showLoading();

    const criteria = {
      divisionGroups: prevSearchCache.selectedDivisions.map((d) => d.code).join("^"),
      location: prevSearchCache.selectedLocationCodeList.join("^"),
      sites: prevSearchCache.selectedSites.map((s) => s.siteId).join("^"),
      models: prevSearchCache.selectedModels.map((m) => m.modelCode).join("^"),
      imei: prevSearchCache.imei.split("\n").map(imei => imei.trim()).filter(imei => imei).join("^"),
      status: prevSearchCache.selectedStatus?.code || "",
      fromDate: moment(prevSearchCache.saleDateFrom).format(formats.apiDateFormat),
      toDate: moment(prevSearchCache.saleDateTo).format(formats.apiDateFormat),
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    };

    SearchByIMEIModel.search(criteria)
      .then((res) => {
        searchResult = res?.data || [];

        pagination.totalItems = res?.total || 0;
        pagination.pageIndex = res?.pageIndex || 1;
        pagination.pageSize = res?.pageSize || 10;

      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    e.target.classList.add("was-validated");

    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    pagination.pageIndex = 1;
    search();
  };

  const handleClickClear = () => {
    saleDateFrom = moment().format(formats.dateFormat);
    saleDateTo = moment().format(formats.dateFormat);
    selectedDivisions = [];
    selectedModels = [];
    imei = "";
    selectedLocationCodeList = [];
    selectedSites = [];
    selectedStatus = undefined;
  }

  const handleChangeSaleDate = (e) => {
    saleDateFrom = moment(e.detail.start).format(formats.dateFormat);
    saleDateTo = moment(e.detail.end).format(formats.dateFormat);
  };

  const handleChangeImei = (e) => {
    imei = e.target.value;
  }

  const handleSelectLocation = (selectedParents) => {
    selectedLocationCodeList = selectedParents;
  }

  const handleSelectSites = (sites) => {
    selectedSites = sites;
  };

  const handleSelectStatus = (status) => {
    selectedStatus = status;
  }

  const handleSelectDivisions = (divisions = []) => {
    selectedDivisions = divisions;
  };

  const handleSelectModels = (models) => {
    selectedModels = models;
  }

  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    searchWithCache();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    searchWithCache();
  };

  const handleClickDownloadResult = () => {
    this.showLoading();

    const config = {
      divisionGroup: prevSearchCache.selectedDivisions.map((d) => d.code).join("^"),
      location: prevSearchCache.selectedLocationCodeList.join("^"),
      channel: prevSearchCache.selectedSites.map((s) => s.siteId).join("^"),
      modelCodes: prevSearchCache.selectedModels.map((m) => m.modelCode).join("^"),
      imei: prevSearchCache.imei.trim().split("\n").filter(imei => imei).join("^"),
      status: prevSearchCache.selectedStatus?.code || "",
      fromDate: moment(prevSearchCache.saleDateFrom).format(formats.apiDateFormat),
      toDate: moment(prevSearchCache.saleDateTo).format(formats.apiDateFormat),
      pageSize: -1,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    }

    SearchByIMEIModel.exportSearchResultToExcel(config)
      .catch((err) => {
        this.handleError(err)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const fetchInitData = () => {
    this.showLoading();

    Promise.all([
      SearchByIMEIModel.getDivisions(loginModel.credentials.country),
      SearchByIMEIModel.getStatuses(),
    ])
      .then(([divisionsRes, statusesRes]) => {
        divisions = divisionsRes;
        statuses = statusesRes;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };


  const flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT;
  }

  const getSortIcon = (orderBy) => {
    if (selectedOrderBy !== orderBy) {
      return null;
    }

    return selectedSortBy === DESCENDING_TEXT
      ? m('i.bi.bi-sort-down')
      : m('i.bi.bi-sort-up');
  };

  const onSortClick = (orderBy) => {
    if (selectedOrderBy === orderBy) {
      selectedSortBy = flipOrderText(selectedSortBy);
    } else {
      selectedOrderBy = orderBy;
      selectedSortBy = DESCENDING_TEXT;
    }
    searchWithCache();
  };

  return {
    oninit: () => {
      fetchInitData();
    },

    view: () => {
      return [
        m('.d-flex.justify-content-end.mb-2',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
        ),

        m('#search-section.collapse.show',
          m(".card",
            m(".card-body",
              m("form.row.g-2.needs-validation[novalidate]", {
                onsubmit: handleSubmitSearch
              },

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='sale-date']", this.getText("LT00000918", "Sales Date")),
                  m(DatePickerComponent, {
                    id: "sale-date",
                    class: "form-control",
                    isRange: true,
                    dateStart: saleDateFrom,
                    dateEnd: saleDateTo,
                    readonly: true,
                    minDays: 1,
                    maxDays: 30,
                    onselect: handleChangeSaleDate,
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m('label.form-label[for="divisions"]', this.getText("LT00008077", "Divisions")),
                  m(MultiSelectComponent, {
                    id: "divisions",
                    items: divisions,
                    selectedItems: selectedDivisions,
                    filterable: true,
                    itemKey: 'code',
                    itemValue: 'name',
                    onSelect: handleSelectDivisions,
                  }),
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m('label.form-label[for="model"]', this.getText("LT00000717", "Model")),
                  m(SelectModelSearchInputComponent, {
                    id: "model",
                    selectedItems: selectedModels,
                    multiple: true,
                    onSelect: handleSelectModels,
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='imei']", this.getText("LT00000908", "IMEI")),
                  m("textarea#imei.form-control[rows='3']", { value: imei, onchange: handleChangeImei }),
                  m(".invalid-feedback.d-block", 
                  this.getText("EM00000819", "Please use Enter key to separate each IMEI. If you key in IMEI, we will ignore Sales Date filter.")
                  // ["Please use", m("b", " Enter "), "key to separate each IMEI.", m("br"), m("span", "If you key in IMEI, we will ignore Sales Date filter.")]
                  )
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='location']", this.getText("LT00000557", "Location")),
                  m(LocationTreeCheckboxComponent, {
                    id: "location",
                    selectedCodes: selectedLocationCodeList,
                    isLevel1Expanded: true,
                    onChange: handleSelectLocation
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='site']", this.getText("LT00000071", "Site")),
                  m(SelectSiteSearchInputComponent, {
                    id: "site",
                    multiple: true,
                    selectedItems: selectedSites,
                    onSelect: handleSelectSites,
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='status']", this.getText("LT00000015", "Status")),
                  m(SingleSelectComponent, {
                    id: "status",
                    items: statuses.filter(s => s.code),
                    selectedItem: selectedStatus,
                    onSelect: handleSelectStatus,
                  })
                ),

                m(".row.g-2.justify-content-end.mt-2.mt-md-3",
                  m(".col-12.gap-2.d-flex.justify-content-end.flex-wrap",
                    m("button.btn.btn-primary",
                      this.getText("LT00000001", "Search")
                    ),

                    m("button.btn.btn-white[type=button]",
                      { onclick: handleClickClear },
                      this.getText("LT00000031", "Clear")
                    )
                  )
                )
              ),
            ),
          ),
        ),

        searchResult &&
        m(".mt-2.card",
          m(".card-body",

            searchResult?.length > 0 &&
            m("div",

              m(".d-md-flex.justify-content-end",
                m(".text-end",
                  m("a.btn.btn-primary",
                    { onclick: handleClickDownloadResult },
                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                    this.getText("LT00000018", "Excel Download"),
                  )
                ),
              ),

              m(".table-responsive.mt-2",
                m("table.table.align-middle", [
                  m("thead",
                    m("tr",
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("surveyDate") } }, getSortIcon('surveyDate'), this.getText("LT00000918", "Sales Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("warrantyTo") } }, getSortIcon('warrantyTo'), this.getText("LT00001131", "Warranty To")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("fotaDate") } }, getSortIcon('fotaDate'), this.getText("LT00001187", "FOTA Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("imei") } }, getSortIcon('imei'), this.getText("LabelText", "IMEI/SN")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("divisionGroup") } }, getSortIcon('divisionGroup'), this.getText("LT00000233", "Division")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("modelCode") } }, getSortIcon('modelCode'), this.getText("LT00000717", "Model")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("modelAlias") } }, getSortIcon('modelAlias'), this.getText("LT00001132", "Alias")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("promoterId") } }, getSortIcon('promoterId'), this.getText("LT00000561", "Promoter")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("promoterName") } }, getSortIcon('promoterName'), this.getText("LT00001133", "Promoter Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("customer") } }, getSortIcon('customer'), this.getText("LT00008046", "Customer")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("siteId") } }, getSortIcon('siteId'), this.getText("LT00000723", "Site Code")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("siteName") } }, getSortIcon('siteName'), this.getText("LT00000144", "Site Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("realSellOutYn") } }, getSortIcon('realSellOutYn'), this.getText("LT00001134", "Real Sellout")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("fromSiteId") } }, getSortIcon('fromSiteId'), this.getText("LT00001135", "From Site Code")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("fromSiteName") } }, getSortIcon('fromSiteName'), this.getText("LT00001136", "From Site Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("toSiteId") } }, getSortIcon('toSiteId'), this.getText("LT00001137", "To Site Code")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("toSiteName") } }, getSortIcon('toSiteName'), this.getText("LT00001138", "To Site Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("endUserName") } }, getSortIcon('endUserName'), this.getText("LT00000909", "End User Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("endUserPhoneNo") } }, getSortIcon('endUserPhoneNo'), this.getText("LT00001139", "End User Phone No")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("bussinessType") } }, getSortIcon('bussinessType'), this.getText("LT00001140", "Business Type")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("createUserId") } }, getSortIcon('createUserId'), this.getText("LT00001141", "Created by ID")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("createUserName") } }, getSortIcon('createUserName'), this.getText("LT00000709", "Created by")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("createDate") } }, getSortIcon('createDate'), this.getText("LT00000041", "Create Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("inputTypeCode") } }, getSortIcon('inputTypeCode'), this.getText("LT00001142", "Input Type Code")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("inputTypeName") } }, getSortIcon('inputTypeName'), this.getText("LT00001143", "Input Type Name")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("deleteDate") } }, getSortIcon('deleteDate'), this.getText("LT00001144", "Deleted Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("doaDate") } }, getSortIcon('doaDate'), this.getText("LT00001145", "DOA Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("deactivatedByID") } }, getSortIcon('deactivatedByID'), this.getText("LT00001146", "Deactivated by ID")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("deactivationDate") } }, getSortIcon('deactivationDate'), this.getText("LT00001147", "Deactivation Date")),
                      m("th.cursor-pointer[scope=col]", { onclick: () => { onSortClick("deactivationReason") } }, getSortIcon('deactivationReason'), this.getText("LT00000949", "Deactivation Reason")),
                    )
                  ),
                  m("tbody",
                    searchResult.map((item) =>
                      m("tr",
                        m("td", item.surveyDate),
                        m("td", item.warrantyTo),
                        m("td", item.fotaDate),
                        m("td", item.imei), 
                        m("td", item.divisionGroup),
                        m("td", item.modelCode),
                        m("td", item.modelAlias),
                        m("td", item.promoterId),
                        m("td", item.promoterName),
                        m("td", item.customer),
                        m("td", item.siteId),
                        m("td", item.siteName),
                        m("td", item.realSellOutYn),
                        m("td", item.fromSiteId),
                        m("td", item.fromSiteName),
                        m("td", item.toSiteId),
                        m("td", item.toSiteName),
                        m("td", item.endUserName),
                        m("td", item.endUserPhoneNo),
                        m("td", item.bussinessType),
                        m("td", item.createUserId),
                        m("td", item.createUserName),
                        m("td", item.createDate),
                        m("td", item.inputTypeCode),
                        m("td", item.inputTypeName),
                        m("td", item.deleteDate),
                        m("td", item.doaDate),
                        m("td", item.deactivatedByID),
                        m("td", item.deactivationDate),
                        m("td", item.deactivationReason),
                      )
                    ),
                  ),
                ])
              ),

              m(".px-3",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  data: searchResult,
                  onPageChanged: handlePageChanged,
                  onPageSizeChanged: handlePageSizeChanged,
                })
              )
            ),

            searchResult?.length === 0 && this.getText("EM00000141", "No records found.")

          )
        ),

        this.getBaseViews()
      ]
    }
  }
}